import React, { Suspense } from "react";

import { CircularProgress, Stack } from "@mui/material";

// Both guest menus are large; load them only when a preview is shown, so the
// header and settings pages don't carry them.
const GuestMenuVersionPreview = React.lazy(() =>
  import("./GuestMenuVersionPreview").then((module) => ({
    default: module.GuestMenuVersionPreview,
  }))
);

export const LazyGuestMenuVersionPreview = (
  props: React.ComponentProps<typeof GuestMenuVersionPreview>
) => (
  <Suspense
    fallback={
      <Stack
        alignItems="center"
        justifyContent="center"
        sx={{ height: "100%" }}
      >
        <CircularProgress size={24} />
      </Stack>
    }
  >
    <GuestMenuVersionPreview {...props} />
  </Suspense>
);
